import * as React from "react"
import { Spinner } from './Spinner'
import './PageLoader.css'

/**
 * Full-viewport loader for route boundaries + initial auth check.
 * Don't use this inside a card or panel — use <Spinner> directly there.
 */
export function PageLoader(): React.JSX.Element {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <Spinner size="lg" label="Loading page" />
    </div>
  )
}
